export const LANGS = ['pt', 'en'];

export const content = {
  pt: {
    meta: {
      title: 'dooloop · produtos para contexto, operação e governança',
      description:
        'A dooloop transforma contexto fragmentado, execução manual, aprovações soltas e evidências em produtos de software para times de DevOps, plataforma e operações.'
    },
    nav: {
      products: 'Produtos',
      method: 'Método',
      why: 'Por que dooloop',
      cta: 'Lista de espera'
    },
    home: {
      hero: {
        badge: 'contexto · operação · governança · ia aplicada',
        titleA: 'Pare de perder tempo',
        titleHighlight: 'procurando contexto e controlando no braço.',
        subtitle:
          'A dooloop cria produtos para descobrir ambiente, padronizar execução, governar acessos e mudanças, gerar evidência sem planilha e dar rastreabilidade real para entrega técnica.',
        ctaPrimary: 'Entrar na lista de espera',
        ctaSecondary: 'Explorar produtos',
        proof: [
          'menos dependência de pessoas-chave',
          'execução padronizada',
          'aprovação com trilha',
          'evidência pronta para auditoria'
        ],
        terminal: {
          title: 'dooloop.platform',
          lines: [
            { key: 'problema', value: 'contexto fragmentado + operação manual' },
            { key: 'abordagem', value: 'produto + workflow + rastreabilidade' },
            { key: 'resultado', value: 'governança operacional escalável' }
          ]
        }
      },
      marquee: [
        'context hub',
        'runbook ops',
        'access & change control',
        'evidence ops',
        'delivery governance',
        'workflow orchestration',
        'audit trail',
        'ai with control'
      ],
      products: {
        eyebrow: 'produtos',
        title: 'Cinco produtos para tirar contexto, execução e controle do improviso.',
        subtitle:
          'Cada módulo resolve uma dor operacional clara, mas todos compartilham a mesma fundação de workflow, trilha e governança.',
        more: 'Ver página do produto',
        items: [
          {
            slug: 'context-hub',
            tag: 'produto · 01',
            title: 'Dooloop Context Hub',
            text: 'Descoberta de contexto, ownership, dependências e histórico operacional em uma camada viva e consultável.',
            points: ['Busca com fonte', 'Mapa de sistemas e ambientes', 'Onboarding mais rápido']
          },
          {
            slug: 'runbook-ops',
            tag: 'produto · 02',
            title: 'Dooloop Runbook Ops',
            text: 'Runbooks versionados, troubleshooting guiado e execução com evidência para operação repetível.',
            points: ['Execução guiada', 'Passos manuais e automáticos', 'Trilha por step']
          },
          {
            slug: 'access-change-control',
            tag: 'produto · 03',
            title: 'Dooloop Access & Change Control',
            text: 'Acessos temporários, changes críticos e aprovações com política, janela e checklist.',
            points: ['Fluxos de aprovação', 'Mudança governada', 'Break-glass rastreável']
          },
          {
            slug: 'evidence-ops',
            tag: 'produto · 04',
            title: 'Dooloop Evidence Ops',
            text: 'Evidência operacional ligada a controles, execuções, aprovações e artefatos sem depender de planilha.',
            points: ['Pacotes de auditoria', 'Mapeamento por controle', 'Prova com origem']
          },
          {
            slug: 'delivery-governance',
            tag: 'produto · 05',
            title: 'Dooloop Delivery Governance',
            text: 'Rastreabilidade de mudança, pipeline, deploy e uso de IA com controles de revisão e risco.',
            points: ['Lineage ponta a ponta', 'Oversight para IA', 'Bloqueios por política']
          }
        ]
      },
      method: {
        eyebrow: 'método',
        title: 'Como a dooloop transforma dor operacional em produto.',
        subtitle:
          'A lógica é simples: entender o contexto real, empacotar o processo, aplicar controles e transformar a rotina em fluxo reutilizável.',
        steps: [
          { n: '01', title: 'Ler o ambiente', text: 'Entramos no contexto real: sistemas, stacks, dependências, gargalos e handoffs.' },
          { n: '02', title: 'Modelar o processo', text: 'Transformamos o que hoje vive em chat, planilha ou cabeça em workflow claro.' },
          { n: '03', title: 'Governar a execução', text: 'Aprovação, política, evidência e rastreabilidade entram no fluxo desde o início.' },
          { n: '04', title: 'Virar produto', text: 'O que antes era improviso vira módulo escalável com backlog, integrações e roadmap.' }
        ],
        loopLabel: 'contexto → fluxo → controle'
      },
      why: {
        eyebrow: 'por que dooloop',
        title: 'Uma plataforma para o que normalmente fica espalhado entre ferramentas e pessoas.',
        cards: [
          { title: 'Menos contexto perdido', text: 'Ownership, mudanças, runbooks e evidências deixam de ficar espalhados entre ferramentas.' },
          { title: 'Menos toil operacional', text: 'A execução deixa de depender de memória, improviso e coordenação manual.' },
          { title: 'Mais governança sem paralisar', text: 'Aprovação, política e exceção entram com gradação de risco, não como burocracia cega.' },
          { title: 'IA com trilha', text: 'A IA pode resumir, sugerir e apoiar, mas com origem, log e supervisão humana.' },
          { title: 'Base modular', text: 'Cada produto resolve uma dor clara e reaproveita identidade, workflows, eventos e auditoria.' },
          { title: 'Pronto para ambiente sério', text: 'O desenho parte de multiambiente, integrações enterprise e controle operacional real.' }
        ]
      },
      stats: [
        { value: 5, suffix: '', label: 'produtos definidos' },
        { value: 3, suffix: '', label: 'bundles comerciais' },
        { value: 1, suffix: '', label: 'plataforma compartilhada' }
      ]
    },
    waitlist: {
      eyebrow: 'lista de espera',
      title: 'Entre cedo na evolução da suíte dooloop.',
      subtitle:
        'Se você quer colocar contexto, operação e governança no mesmo lugar, entre na lista para acompanhar os produtos e as primeiras implantações.',
      placeholder: 'seu@email.com',
      button: 'Quero acompanhar',
      sending: 'Enviando…',
      success: 'Pronto! Você entrou na lista.',
      error: 'Algo deu errado. Tente novamente.',
      invalid: 'Digite um e-mail válido.',
      disclaimer: 'Sem spam. Só atualizações relevantes.'
    },
    productPage: {
      outcomes: 'Resultados',
      buyers: 'Para quem é',
      buyersTitle: 'Times e compradores',
      pain: 'Dor principal',
      painTitle: 'O que esse produto elimina',
      description: 'Descrição',
      descriptionTitle: 'O que esse produto é na prática',
      servesFor: 'Para que serve',
      servesForTitle: 'Onde ele gera valor',
      insideCompany: 'Uso na empresa',
      insideCompanyTitle: 'Como ele entra na operação',
      companyUsageEyebrow: 'uso no dia a dia',
      companyUsageTitle: 'Como diferentes times usam',
      scenariosEyebrow: 'cenários',
      scenariosTitle: 'Situações em que ele faz diferença',
      curiosityEyebrow: 'por que olhar mais de perto',
      curiosityTitle: 'A pergunta que esse produto provoca',
      capabilitiesEyebrow: 'capacidades',
      capabilitiesTitle: 'O que o produto precisa fazer',
      capabilitiesSubtitle: 'Blocos centrais que definem aplicação, workflows e integração.',
      processEyebrow: 'processo',
      processTitle: 'Como funciona na prática',
      processSubtitle: 'Fluxo operacional esperado, do gatilho ao resultado governado.',
      integrations: 'Integrações',
      integrationsTitle: 'Sistemas que precisam se conectar',
      technology: 'Tecnologia',
      technologyTitle: 'Stack compartilhada recomendada',
      roadmapEyebrow: 'roadmap',
      roadmapTitle: 'Caminho de MVP até expansão',
      roadmapSubtitle: 'Sequência de construção alinhada à plataforma Dooloop.',
      backlogEyebrow: 'backlog de entrega',
      backlogTitle: 'Temas principais do backlog',
      backlogSubtitle: 'O detalhamento completo está no repositório. Aqui ficam as frentes centrais de implementação.',
      navCapabilities: 'Capacidades',
      navStack: 'Stack',
      navRoadmap: 'Roadmap',
      ctaRoadmap: 'Ver roadmap'
    },
    footer: {
      tagline: 'Produtos para contexto, execução e governança operacional.',
      rights: '© 2026 dooloop. Todos os direitos reservados.',
      emailLabel: 'Contato',
      email: 'contato@dooloop.com.br',
      nav: 'Navegação',
      backToTop: 'Voltar ao topo',
      home: 'Home'
    }
  },
  en: {
    meta: {
      title: 'dooloop · products for context, execution and governance',
      description:
        'dooloop turns fragmented context, manual execution, loose approvals and spreadsheet evidence into software products for DevOps, platform and operations teams.'
    },
    nav: {
      products: 'Products',
      method: 'Method',
      why: 'Why dooloop',
      cta: 'Waitlist'
    },
    home: {
      hero: {
        badge: 'context · operations · governance · applied ai',
        titleA: 'Stop wasting time',
        titleHighlight: 'hunting for context and controlling work by hand.',
        subtitle:
          'dooloop builds products to discover environments, standardize execution, govern access and changes, generate evidence without spreadsheets, and create real delivery traceability.',
        ctaPrimary: 'Join the waitlist',
        ctaSecondary: 'Explore products',
        proof: [
          'less dependency on key people',
          'standardized execution',
          'approval with traceability',
          'audit-ready evidence'
        ],
        terminal: {
          title: 'dooloop.platform',
          lines: [
            { key: 'problem', value: 'fragmented context + manual operations' },
            { key: 'approach', value: 'product + workflow + traceability' },
            { key: 'outcome', value: 'scalable operational governance' }
          ]
        }
      },
      marquee: [
        'context hub',
        'runbook ops',
        'access & change control',
        'evidence ops',
        'delivery governance',
        'workflow orchestration',
        'audit trail',
        'ai with control'
      ],
      products: {
        eyebrow: 'products',
        title: 'Five products built to remove guesswork from context, execution and control.',
        subtitle:
          'Each module solves a distinct operational pain while sharing the same workflow, audit and governance foundation.',
        more: 'Open product page',
        items: [
          {
            slug: 'context-hub',
            tag: 'product · 01',
            title: 'Dooloop Context Hub',
            text: 'Context discovery, ownership, dependencies and operational history in a living, queryable layer.',
            points: ['Grounded search', 'System and environment map', 'Faster onboarding']
          },
          {
            slug: 'runbook-ops',
            tag: 'product · 02',
            title: 'Dooloop Runbook Ops',
            text: 'Versioned runbooks, guided troubleshooting and execution with evidence for repeatable operations.',
            points: ['Guided execution', 'Manual and automated steps', 'Step-level trace']
          },
          {
            slug: 'access-change-control',
            tag: 'product · 03',
            title: 'Dooloop Access & Change Control',
            text: 'Temporary access, critical changes and approvals with policy, windows and checklist enforcement.',
            points: ['Approval flows', 'Governed changes', 'Traceable break-glass']
          },
          {
            slug: 'evidence-ops',
            tag: 'product · 04',
            title: 'Dooloop Evidence Ops',
            text: 'Operational evidence linked to controls, executions, approvals and artifacts without spreadsheet dependency.',
            points: ['Audit bundles', 'Control mapping', 'Proof with provenance']
          },
          {
            slug: 'delivery-governance',
            tag: 'product · 05',
            title: 'Dooloop Delivery Governance',
            text: 'Traceability across change, pipeline, deployment and AI usage with review and risk controls.',
            points: ['End-to-end lineage', 'AI oversight', 'Policy-based gates']
          }
        ]
      },
      method: {
        eyebrow: 'method',
        title: 'How dooloop turns operational pain into product.',
        subtitle:
          'The logic is direct: understand the real environment, package the process, apply controls, and turn routine work into reusable flow.',
        steps: [
          { n: '01', title: 'Read the environment', text: 'We start from real systems, stacks, dependencies, bottlenecks and handoffs.' },
          { n: '02', title: 'Model the process', text: 'What lives in chat, spreadsheets or people becomes a defined workflow.' },
          { n: '03', title: 'Govern execution', text: 'Approvals, policy, evidence and traceability enter the flow from day one.' },
          { n: '04', title: 'Turn it into product', text: 'Improvised routine becomes a reusable module with backlog, integrations and roadmap.' }
        ],
        loopLabel: 'context → flow → control'
      },
      why: {
        eyebrow: 'why dooloop',
        title: 'One platform for what usually gets scattered across tools and people.',
        cards: [
          { title: 'Less lost context', text: 'Ownership, changes, runbooks and evidence stop living in disconnected tools.' },
          { title: 'Less operational toil', text: 'Execution stops depending on memory, improvisation and manual coordination.' },
          { title: 'More governance without paralysis', text: 'Approvals, policy and exceptions follow risk, not blind bureaucracy.' },
          { title: 'AI with traceability', text: 'AI can summarize, suggest and assist, but always with source, logs and oversight.' },
          { title: 'Modular foundation', text: 'Each product solves a clear pain while reusing identity, workflows, events and audit.' },
          { title: 'Ready for serious environments', text: 'The design assumes multi-environment deployment, enterprise integrations and real operational control.' }
        ]
      },
      stats: [
        { value: 5, suffix: '', label: 'defined products' },
        { value: 3, suffix: '', label: 'commercial bundles' },
        { value: 1, suffix: '', label: 'shared platform' }
      ]
    },
    waitlist: {
      eyebrow: 'waitlist',
      title: 'Get early access to the dooloop suite.',
      subtitle:
        'If you want context, operations and governance in the same place, join the list to follow the products and first implementations.',
      placeholder: 'you@email.com',
      button: 'Keep me posted',
      sending: 'Sending…',
      success: "You're on the list.",
      error: 'Something went wrong. Try again.',
      invalid: 'Enter a valid email.',
      disclaimer: 'No spam. Only meaningful updates.'
    },
    productPage: {
      outcomes: 'Outcomes',
      buyers: 'Who it is for',
      buyersTitle: 'Teams and buyers',
      pain: 'Main pain',
      painTitle: 'What this product removes',
      description: 'Description',
      descriptionTitle: 'What this product is in practice',
      servesFor: 'Purpose',
      servesForTitle: 'Where it creates value',
      insideCompany: 'Inside the company',
      insideCompanyTitle: 'How it fits into operations',
      companyUsageEyebrow: 'everyday usage',
      companyUsageTitle: 'How different teams use it',
      scenariosEyebrow: 'scenarios',
      scenariosTitle: 'Situations where it makes a difference',
      curiosityEyebrow: 'why look closer',
      curiosityTitle: 'The question this product forces',
      capabilitiesEyebrow: 'capabilities',
      capabilitiesTitle: 'What the product must do',
      capabilitiesSubtitle: 'Core capability blocks that shape the application, workflow model and integration scope.',
      processEyebrow: 'process',
      processTitle: 'How it works in practice',
      processSubtitle: 'Expected operating flow from entry point to governed outcome.',
      integrations: 'Integrations',
      integrationsTitle: 'Expected system connections',
      technology: 'Technology',
      technologyTitle: 'Recommended shared stack',
      roadmapEyebrow: 'roadmap',
      roadmapTitle: 'MVP to expansion path',
      roadmapSubtitle: 'Build sequence aligned with the shared Dooloop platform.',
      backlogEyebrow: 'delivery backlog',
      backlogTitle: 'Backlog themes',
      backlogSubtitle: 'The full breakdown lives in the repo. These are the main implementation tracks.',
      navCapabilities: 'Capabilities',
      navStack: 'Stack',
      navRoadmap: 'Roadmap',
      ctaRoadmap: 'See roadmap'
    },
    footer: {
      tagline: 'Products for context, execution and operational governance.',
      rights: '© 2026 dooloop. All rights reserved.',
      emailLabel: 'Contact',
      email: 'contato@dooloop.com.br',
      nav: 'Navigation',
      backToTop: 'Back to top',
      home: 'Home'
    }
  }
};
